export default "__VITE_ASSET__D$TbKG2d__"